import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'
import { QueryClient, useQueryClient } from 'react-query'

interface CsvAsyncDownloadArgs {
  organizationUuid: string
  csvOptions: object
}
interface CsvAsyncDownloadResponse {
  success: boolean
  messages: string[]
}

export async function getCsvAsyncDownload(
  this: ThisConnector,
  { organizationUuid, csvOptions }: CsvAsyncDownloadArgs
) {
  return this.connector.post(
    `/${organizationUuid}/orgtraces/bulk/export/csv/async`,
    csvOptions
  )
}

function invalidateCsvAsyncDownloadCache(
  queryClient: QueryClient,
  organizationUuid: string
) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  queryClient.invalidateQueries([
    Query.VULN_BULK_CSV_ASYNC_DOWNLOAD,
    organizationUuid
  ])
}

export const useCsvAsyncDownload = ({ organizationUuid, csvOptions }) => {
  const queryClient = useQueryClient()
  invalidateCsvAsyncDownloadCache(queryClient, organizationUuid)
  const { isLoading, error, data } = useContrastQuery<
    CsvAsyncDownloadArgs,
    CsvAsyncDownloadResponse
  >(
    [Query.VULN_BULK_CSV_ASYNC_DOWNLOAD, organizationUuid],
    getCsvAsyncDownload,
    {
      organizationUuid,
      csvOptions
    }
  )

  return {
    isLoading,
    error,
    data
  }
}
